 
import SEO from '../../components/common/seo/SEO'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage' 
import WindchillCourse from '../../data/cad_section/WindchillCourse'

function WindChillPage() {
  return (
<>

     <SEO
        title="PTC Windchill PLM Customization Training | Windchill Course | FeesWorth"

        description="Learn PTC Windchill PLM customization and development with practical projects. Master Windchill customization, Java development, workflows, integrations, PLM concepts, and enterprise product lifecycle management with expert training at FeesWorth."

        keywords="Windchill Training, PTC Windchill Training, Windchill PLM Training, Windchill Customization Course, Windchill Customization Training, Windchill Development, Windchill Java Training, Windchill Workflow Training, Windchill PLM Course, PTC Windchill Course"

        canonical="https://feesworth.com/ptc-windchill-plm-customization-course"
      />
           <CourseLandingPage course={WindchillCourse} />
</>

  )
}

export default WindChillPage